import { Action, Reducer } from "redux";
import { MenuState, MenuTypes, MenuActionTypes } from "./menuTypes";

const INITIAL_STATE: MenuState = {
	menu: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
	menuItemSelected: "",
	open: false,
};

const menuReducer: Reducer<MenuState> = (state: MenuState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as MenuActionTypes;
	switch (actionTypes.type) {
		case MenuTypes.GET_MENU:
			return {
				...state,
				menu: { ...state.menu, isLoading: true },
			};
		case MenuTypes.SAVE_MENU:
			return {
				...state,
				menu: {
					...state.menu,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case MenuTypes.RESET_REDUCER_MENU:
			return {
				...state,
				menu: INITIAL_STATE.menu,
			};
		case MenuTypes.SET_MENU_ITEM_SELECTED:
			return {
				...state,
				menuItemSelected: actionTypes.payload.menuItemSelected,
			};
		case MenuTypes.SET_OPEN_MENU:
			return {
				...state,
				open: actionTypes.payload.open,
			};
		default:
			return state;
	}
};

export default menuReducer;
